import { render, staticRenderFns } from "./CancelServicesReservation.vue?vue&type=template&id=48d47fae&scoped=true&"
import script from "./CancelServicesReservation.vue?vue&type=script&lang=js&"
export * from "./CancelServicesReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d47fae",
  null
  
)

export default component.exports